__turbopack_context__.v({
  "container": "desktop-navigation-module-scss-module__QBSCeW__container",
  "content": "desktop-navigation-module-scss-module__QBSCeW__content",
  "contentScroll": "desktop-navigation-module-scss-module__QBSCeW__contentScroll",
  "footer": "desktop-navigation-module-scss-module__QBSCeW__footer",
  "gap": "desktop-navigation-module-scss-module__QBSCeW__gap",
  "header": "desktop-navigation-module-scss-module__QBSCeW__header",
  "inner": "desktop-navigation-module-scss-module__QBSCeW__inner",
  "root": "desktop-navigation-module-scss-module__QBSCeW__root",
});
